import { useCallback, useMemo } from "react";
import { Trans } from "@lingui/macro";

/**
 * Internal dependencies.
 */
import Link from "components/link/link";
import { getSlug } from "utils";
import { useRouter } from "next/router";

interface ItemProp {
  id: number;
  attributes: {
    Title?: string;
    Content?: string;
    slug?: string;
  };
}

interface ThemeProp {
  data: {
    id: number;
    attributes: {
      Content?: string;
      slug?: string;
    };
  };
}

interface CetegoryProp {
  id: number;
  attributes: {
    Title?: string;
    slug?: string;
    documentations: {
      data: ItemProp[];
    };
    theme?: ThemeProp;
  };
}

interface CategoriesListingProp {
  categories: CetegoryProp[];
  app?: boolean;
}

const CategoriesListing: React.FC<CategoriesListingProp> = ({
  categories,
  app,
}) => {
  const router = useRouter();
  const key = app ? "apps" : "themes";
  const generateLink = (item: ItemProp) => {
    let link = `/help-center/documentation/${app ? "app" : "theme"}/`;
    link += `${router.query.theme}/${getSlug(item.attributes)}`;
    return link;
  };

  const filterCategories = useMemo(
    () =>
      categories?.filter((item: any) => {
        const theme = item.attributes.documentations.data.find(
          ({ attributes }: any) => {
            return attributes[key].data.find(({ attributes: theme }: any) => {
              return (
                theme.slug_overwrite === router.query.theme ||
                theme.slug === router.query.theme
              );
            });
          }
        );

        return item.attributes.documentations.data.length > 0 && theme;
      }),
    [categories]
  );

  const filterDocs = useCallback(
    (docs: any) =>
      docs.filter(({ attributes }: any) => {
        return attributes[key].data.find(({ attributes: theme }: any) => {
          return (
            theme.slug_overwrite === router.query.theme ||
            theme.slug === router.query.theme
          );
        });
      }),
    []
  );

  return (
    <div className="categories-listing">
      {filterCategories?.map(({ attributes, id }: CetegoryProp) => (
        <div className="categories-box" key={id}>
          <h6>{attributes.Title}</h6>
          <ul>
            {filterDocs(attributes.documentations.data)
              .slice(0, 5)
              .map((item: ItemProp) => (
                <li key={item.id}>
                  <Link href={generateLink(item)}>{item.attributes.Title}</Link>
                </li>
              ))}
          </ul>
          {filterDocs(attributes.documentations.data).length > 5 && (
            <Link
              href={generateLink(filterDocs(attributes.documentations.data)[0])}
              className="categories-listing__all"
            >
              <Trans>See all</Trans>{" "}
              {filterDocs(attributes.documentations.data).length}{" "}
              <Trans>articles</Trans>
            </Link>
          )}
        </div>
      ))}
    </div>
  );
};

export default CategoriesListing;
